import { Box, Card, Paper, SxProps, Theme, Typography } from '@mui/material';
import { DollarCell } from 'shared/tables/DollarCell';

const cardStyles: SxProps<Theme> = {
  marginTop: '15px',
  padding: '15px',
};
const cardRootStyles: SxProps<Theme> = { overflow: 'unset' };
const statsContainerStyles: SxProps<Theme> = {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-around',
  width: '100%',
  padding: '0 10% 0 10%',
};
const statPaperStyles: SxProps<Theme> = {
  marginTop: '15px',
  marginLeft: '5px',
  padding: '5px',
  height: 100,
  minWidth: 150,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
};

interface QuoteStatsProps {
  revenue?: number;
  margin?: number;
  createdBy?: string;
  createDate?: string;
  expirationDate?: string;
  // onUpdateExpirationDate: (date:string) => void
}

export const QuoteStats = ({ revenue, margin, createdBy, createDate }: QuoteStatsProps) => {
  const formattedDate = createDate ? new Date(createDate).toLocaleDateString() : '-';
  return (
    <Card sx={{ ...cardStyles, ...cardRootStyles }}>
      <Typography variant='h5'>Stats</Typography>
      <Box sx={statsContainerStyles}>
        <Paper sx={statPaperStyles}>
          <Typography color='secondary' variant='h5'>
            {typeof revenue !== 'undefined' ? <DollarCell value={revenue} /> : '-'}
          </Typography>
          <Typography variant='body2'>Total Order Value</Typography>
        </Paper>
        {/* <Paper sx={statPaperStyles}>
          <Typography color='secondary' variant='h5'>
            {typeof margin !== 'undefined' ? <PercentCell value={margin} /> : '-'}
          </Typography>
          <Typography variant='body2'>Margin</Typography>
        </Paper> */}
        <Paper sx={statPaperStyles}>
          <Typography color='secondary' variant='body1'>
            {createdBy || '-'}
          </Typography>
          <Typography variant='body2'>Created By</Typography>
        </Paper>
        <Paper sx={statPaperStyles}>
          <Typography color='secondary' variant='body1'>
            {formattedDate}
          </Typography>
          <Typography variant='body2'>Created Date</Typography>
        </Paper>
      </Box>
    </Card>
  );
};
